import React, {useState} from 'react'
import InviteTextGenerator from "../InviteTextGenerator/InviteTextGenerator";
import './style.scss'

export default function InviteTextGeneratorWithHandler(
    {
        weddingData,
        onSaveData,
        language = null
    }
) {

    const [show, setShow] = useState(false)



    return (<>

            <div className={"invite-text-gen-with-handler-button"} onClick={() => setShow(true)}>
                Generează text cu AI
            </div>

           <InviteTextGenerator
               show={show}
               setShow={setShow}
               weddingData={weddingData}
               onSaveData={onSaveData}
               language={language}
               />
        </>
    )

}
